
import {
  Vue, Component, Prop,
} from 'vue-property-decorator';

@Component
export default class UpdateButton extends Vue {
  @Prop({ type: Boolean, default: false }) readonly closeButton!: boolean;
  @Prop({ type: Boolean, default: false }) readonly useConnection!: boolean;
  @Prop({ type: Boolean, default: false }) readonly useTask!: boolean;

  // Sto caricando la Connection/Task
  get loading(): boolean {
    if (this.useConnection) {
      return this.$store.getters.isConnectionLoading;
    }
    if (this.useTask) {
      return this.$store.getters.isTaskLoading;
    }
    return false;
  }

  // Sto aggiornando la Connection/Task
  get updating(): boolean {
    if (this.useConnection) {
      return this.$store.getters.isConnectionUpdating;
    }
    if (this.useTask) {
      return this.$store.getters.isTaskUpdating;
    }
    return false;
  }

  // È necessario salvare le modifiche al Task?
  get dirty(): boolean {
    if (this.useConnection) {
      return this.$store.getters.isConnectionDirty;
    }
    if (this.useTask) {
      return this.$store.getters.isTaskDirty;
    }
    return false;
  }

  onSave() {
    console.log(`${this.constructor.name}: onSave()`); // eslint-disable-line no-console

    this.$emit('save');
  }

  onClose() {
    console.log(`${this.constructor.name}: onClose()`); // eslint-disable-line no-console

    this.$emit('close');
  }
}
